import { Box, styled } from '@arpeggi/ui'
import { EmptyState } from '../../empty-state'

const Container = styled(Box, {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '400px',
  marginTop: '-200px'
})

const Root = styled(EmptyState.Root, {
  width: '450px'
})

const OpacityGradientContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  pointerEvents: 'none',
  WebkitMaskImage:
    '-webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)))'
})

export const TokenGatedEmptyState = { Container, Root, OpacityGradientContainer }
